<template>
  <Content id="screeningDataInfo">
    <div slot="search">
      <Form :label-width="60" :model="search" id="searchForm">
        <Row>
          <Col><FormItem label="条形码"><el-input v-model="search.barCode" :maxlength="13" :clearable="true" @input="toInt()"/></FormItem></Col>
          <Col><FormItem label="姓名" :label-width="45"><el-input v-model="search.name" :maxlength="50" :clearable="true"/></FormItem></Col>
          <Col><FormItem label="证件号码" :label-width="75"><el-input v-model="search.idCard" :maxlength="18" :clearable="true" style="width: 100%;"/></FormItem></Col>
          <Col>
            <FormItem label="体检任务"  prop="taskId" :label-width="75">
              <el-select v-model.trim="search.taskId" placeholder="体检任务"
                         clearable filterable size="small" transfer="true" :popper-append-to-body="false" style="min-width: 350px;">
                <el-option v-for="item in taskList" :key="item.value" :label="item.label" :value="item.value"
                           @click.native="handleTaskChange(item)" style="min-width: 350px;"/>
              </el-select>
            </FormItem>
          </Col>
          <Col v-if="!moreCondition">
            <div style="display:flex;">
              &nbsp;&nbsp;<Button type="primary" @click="query">查询</Button>
              &nbsp;&nbsp;<Button type="warning" @click="chiefInspector">总检</Button>
              &nbsp;&nbsp;
              <el-button type="text" style="font-size: 16px;" @click="moreConditionHandle"> {{ moreCondition ? '隐藏条件' : '更多条件'}}</el-button>
            </div>
          </Col>
        </Row>
        <Row v-if="moreCondition">
          <Col span="5">
            <FormItem  label="学校名称"  prop="schoolId" :label-width="75">
              <el-select v-model.trim="search.schoolId" placeholder="学校名称"
                         clearable filterable size="small" transfer="true" :popper-append-to-body="false"
                         style="width: 100%;" @change="changeSchool">
                <el-option v-for="item in schoolsList" :key="item.value" :label="item.label" :value="item.value"
                           @click.native="handleShoolChange(item)" style="width: 100%;"/>
              </el-select>
            </FormItem>
          </Col>
          <Col>
            <FormItem  label="年级"  prop="gradeId" :label-width="45">
              <el-select v-model.trim="search.gradeId" placeholder="年级"
                         clearable filterable size="small" transfer="true" :popper-append-to-body="false"
                         style="width: 100%;" @change="changeGrade">
                <el-option v-for="item in gradeList" :key="item.id" :label="item.name" :value="item.id"
                           @click.native="handleGradeChange(item)" style="width: 100%;"/>
              </el-select>
            </FormItem>
          </Col>
          <Col>
            <FormItem  label="班级"  prop="classesId" :label-width="45">
              <el-select v-model.trim="search.classesId" placeholder="班级"
                         clearable filterable size="small" transfer="true"
                         style="width: 100%;" :popper-append-to-body="false">
                <el-option v-for="item in classesList" :key="item.id" :label="item.name" :value="item.id"
                           @click.native="handleClassChange(item)" style="width: 100%;"/>
              </el-select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="体检任务日期" :label-width="100">
              <DatePicker  style="width:114px ;" type="date" :editable="false" placeholder="起始日期" format="yyyy-MM-dd" v-model="search.startTaskDate"  @on-change="changeTaskStart"/>
              <DatePicker style="width:114px ;" type="date" :editable="false" placeholder="结束日期" format="yyyy-MM-dd" v-model="search.endTaskDate" @on-change="changeTaskEnd"/>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="体检日期" :label-width="75">
              <DatePicker  style="width:114px ;" type="date" :editable="false" placeholder="起始日期" format="yyyy-MM-dd" v-model="search.startPhysicalDate"  @on-change="changestart"/>
              <DatePicker style="width:114px ;" type="date" :editable="false" placeholder="结束日期" format="yyyy-MM-dd" v-model="search.endPhysicalDate" @on-change="changeend"/>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="抽血日期" :label-width="75">
              <DatePicker style="width:114px ;" type="date" :editable="false" placeholder="起始日期" format="yyyy-MM-dd" v-model="search.drawBloodStartDate"  @on-change="changeDrawBloodStart"/>
              <DatePicker style="width:114px ;" type="date" :editable="false" placeholder="结束日期" format="yyyy-MM-dd" v-model="search.drawBloodEndDate" @on-change="changeDrawBloodEnd"/>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="业务类型" :label-width="75">
              <el-select v-model.trim="search.businessTypeId" placeholder="业务类型"
                         clearable filterable size="small" transfer="true" :popper-append-to-body="false" style="width: 100%;min-width: 130px">
                <el-option v-for="item in businessTypes" :key="item.value" :label="item.label" :value="item.value" style="width: 100%;"/>
              </el-select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="常规体检" :label-width="75">
              <Select v-model="search.conventional" style="min-width: 80px;" :clearable="true">
                <Option v-for="item in conventionalList" :value="item.value" v-bind:key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>
          </Col>
          <!--
          <Col>
            <FormItem label="常规加项" :label-width="75">
              <Select v-model="search.convOptionsStatus" style="min-width: 80px;" :clearable="true">
                <Option v-for="item in convOptionsStatusList" :value="item.value" v-bind:key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>
          </Col>
          -->
          <Col>
            <FormItem label="抽血体检" :label-width="75">
              <Select v-model="search.bloodDraw" style="min-width: 80px;" :clearable="true">
                <Option v-for="item in bloodDrawList" :value="item.value" v-bind:key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="抽血加项" :label-width="75">
              <Select v-model="search.optionsStatus" style="min-width: 80px;" :clearable="true">
                <Option v-for="item in optionsStatusList" :value="item.value" v-bind:key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="体检类型" :label-width="75">
              <Select v-model="search.type" style="min-width: 80px;" :clearable="true">
                <Option v-for="item in typeList" :value="item.value" v-bind:key="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="体检状态" :label-width="75">
              <Select v-model="search.globalCheckStatus" style="width: 100%;min-width: 80px;" :clearable="true">
                <Option v-for="item in enums.globalCheckStatus" :value="item.value" v-bind:key="item.value" style="width: 100%;">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="抽血状态" :label-width="75">
              <Select v-model="search.lisCheckStatus" style="width: 100%;min-width: 90px;" :clearable="true">
                <Option v-for="item in lisCheckStatusList" :value="item.value" v-bind:key="item.value" style="width: 100%;">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="发布状态" :label-width="75">
              <Select v-model="search.publishStatus" style="width: 100%;min-width: 80px;" :clearable="true">
                <Option v-for="item in enums.publishStatus" :value="item.value" v-bind:key="item.value" style="width: 100%;">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="收表状态" :label-width="75">
              <Select v-model="search.collectionStatus" style="width: 100%;min-width: 90px;" :clearable="true">
                <Option v-for="item in collectionStatusList" :value="item.value" v-bind:key="item.value" style="width: 100%;">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="状态" :label-width="45">
              <Select v-model="search.status" style="width: 100%;min-width: 60px;" :clearable="true">
                <Option v-for="item in enums.status" :value="item.value" v-bind:key="item.value" style="width: 100%;">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <div style="display:flex;">
              &nbsp;&nbsp;<Button type="primary" @click="query">查询</Button>
              &nbsp;&nbsp;<Button type="warning" @click="chiefInspector">总检</Button>
              &nbsp;&nbsp;
              <el-button type="text" style="font-size: 16px;" @click="moreConditionHandle"> {{ moreCondition ? '隐藏条件' : '更多条件'}}</el-button>
            </div>
          </Col>
        </Row>
      </Form>
    </div>

    <Row>
      <div style="margin-top: 5px;width: 100%;">
        <div style="float: left;">
          <Button size="small" icon="md-add" @click="handleCreate" type="primary">添加</Button>
          <Button size="small" style="margin-left: 5px;" @click="exportData" type="primary">导出体检数据</Button>
          <Button size="small" style="margin-left: 5px;" @click="exportPhysicalDetail" type="primary">导出体检明细</Button>
          <el-dropdown size="mini" type="primary" style="margin-left: 5px;" split-button @click="handleStatisticsClick('1')"  @command="handleStatisticsClick">导出统计
            <el-dropdown-menu>
              <el-dropdown-item command="1">体检任务统计</el-dropdown-item>
              <el-dropdown-item command="2">体检班级统计</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <Button size="small" style="margin-left: 5px;" @click="exportOphthalmology" type="primary">导出视力筛查</Button>

          <el-dropdown size="mini" type="primary" style="margin-left: 5px;" split-button @click="handleHealthPromotionClick('1')"  @command="handleHealthPromotionClick">导出健促
            <el-dropdown-menu>
              <el-dropdown-item command="1">健促体检数据</el-dropdown-item>
              <el-dropdown-item command="2">健促眼科数据</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <el-dropdown size="mini" split-button type="primary" style="margin-left: 5px;" @click="handleImportClick('1')"  @command="handleImportClick">导入体检数据
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1">视力屈光</el-dropdown-item>
              <el-dropdown-item command="2">屈光数据</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>

        <div style="float: right; margin-right: 15px;">
          <Button size="small" style="margin-left: 5px;" @click="batchEvaluate" type="default" :disabled="notifyInstance != null">批量评价</Button>
          <Button size="small" style="margin-left: 5px;" @click="batchPublish" type="default">批量发布</Button>
          <Button size="small" style="margin-left: 5px;" @click="batchRevocate" type="default">批量撤回</Button>
          <!--          <Button size="small" style="margin-left: 5px;" @click="batchPrintNotice" type="default">打印协议书</Button>-->
          <Button size="small" style="margin-left: 5px;" @click="batchPrintBarcode" type="default">批量打印条形码</Button>
          <Button size="small" style="margin-left: 5px;" @click="batchPhysicalForm">批量打印体检表</Button>
          <Button size="small" style="margin-left: 5px;" @click="batchDownLoadReport" type="default">下载体检报告</Button>
        </div>
      </div>
    </Row>

    <el-table :data="dataList" style="width: 100%;" :header-cell-style="{ background: '#f8f8f9', color: '#515a6e', 'text-align': 'center'}"
              :row-class-name="tableRowClassName" @row-click="handleRowClick" @selection-change="selectList" tooltip-effect="dark"
              highlight-current-row highlight-selection-row row-key="id" :max-height="tableHeight">

      <el-table-column fixed="left" type="selection" width="30"/>
      <el-table-column fixed="left" align="center" prop="barCode" label="条形码" min-width="130"/>
      <el-table-column fixed="left" align="center" prop="name" label="名称" min-width="100"/>
      <el-table-column fixed="left" align="center" prop="taskName" label="体检任务" min-width="230"/>
      <el-table-column align="center" prop="gender" label="性别" min-width="80">
        <template slot-scope="{row}">{{ row.gender===1?'男':row.gender===2?'女':''}}</template>
      </el-table-column>
      <el-table-column align="center" prop="birthday" label="出生日期" min-width="110"/>
      <el-table-column align="center" prop="age" label="年龄" min-width="80"/>
      <el-table-column align="center" prop="idCardType" label="证件类型" min-width="150">
        <template slot-scope="{row}">{{  enums.idCardTypes.filter(u => u.value === row.idCardType)[0].label }}</template>
      </el-table-column>
      <el-table-column align="center" prop="idCard" label="证件号码" min-width="180"/>
      <el-table-column align="center" prop="phone" label="手机号码" min-width="130"/>
      <el-table-column align="center" prop="packagesName" label="体检套餐" min-width="200"/>
      <el-table-column align="center" prop="businessTypeName" label="业务类型" min-width="200"/>
      <el-table-column align="center" prop="reportTemplateName" label="体检报告" min-width="200"/>
      <el-table-column align="center" prop="schoolName" label="学校" min-width="200"/>
      <el-table-column align="center" prop="gradeName" label="年级" min-width="110"/>
      <el-table-column align="center" prop="classesName" label="班级" min-width="150"/>
      <el-table-column align="center" prop="physicalDate" label="体检日期" min-width="120">
        <template slot-scope="{row}">
          <i class="el-icon-time" v-if="row.physicalDate"/><span style="margin-left: 5px">{{ row.physicalDate }}</span>
        </template>
      </el-table-column>
      <!--
      <el-table-column align="center" prop="convOptionsStatus" label="常规加项" min-width="80">
        <template slot-scope="{row}">
          <el-tag size="small" :type="row.convOptionsStatus === 1 ? 'primary' : row.optionsStatus === 2 ? 'success' : ''" disable-transitions>
            {{ row.convOptionsStatus === 1 ? '无加项' : row.convOptionsStatus === 2 ? '有加项' : '' }}
          </el-tag>
        </template>
      </el-table-column>
      -->
      <el-table-column align="center" prop="drawBloodDate" label="抽血日期" min-width="120">
        <template slot-scope="{row}">
          <i class="el-icon-time" v-if="row.drawBloodDate"/><span style="margin-left: 5px">{{ row.drawBloodDate }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="optionsStatus" label="抽血加项" min-width="80">
        <template slot-scope="{row}">
          <el-tag size="small" :type="row.optionsStatus === 1 ? 'primary' : row.optionsStatus === 2 ? 'success' : ''" disable-transitions>
            {{ row.optionsStatus === 1 ? '无加项' : row.optionsStatus === 2 ? '有加项' : '' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="globalCheckStatus" label="检查状态" min-width="100">
        <template slot-scope="{row}">
          <el-tag size="small" :type="row.globalCheckStatus===1?'danger':row.globalCheckStatus===2?'danger':row.globalCheckStatus===3?'warning':'primary'" disable-transitions>
            {{ enums.globalCheckStatus.filter(u => u.value === row.globalCheckStatus)[0].label }}
          </el-tag>
        </template>
      </el-table-column>
      <!--
      <el-table-column align="center" prop="physicalCheckStatus" label="常规体检" min-width="100">
        <template slot-scope="{row}">
          <el-tag size="small" :type="row.physicalCheckStatus===3?'primary':row.physicalCheckStatus===2?'warning':'danger'" disable-transitions>
            {{ row.physicalCheckStatus == 3 ? '已检查' : row.physicalCheckStatus == 2 ? '部分已检' : '未检查'}}
          </el-tag>
        </template>
      </el-table-column>
      -->
      <el-table-column align="center" prop="lisCheckStatus" label="抽血状态" min-width="100">
        <template slot-scope="{row}">
          <el-tag size="small" :type="row.lisCheckStatus===3?'primary':row.lisCheckStatus===2?'warning':'danger'" disable-transitions>
            {{ row.lisCheckStatus === 3 ? '已抽血' : row.lisCheckStatus === 2 ? '部分抽血' : '未抽血'}}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="publishStatus" label="发布状态" min-width="100">
        <template slot-scope="{row}">
          <el-tag size="small " :type="row.publishStatus===2?'primary':'danger'" disable-transitions>
            {{  enums.publishStatus.filter(u => u.value === row.publishStatus)[0].label }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="collectionStatus" label="是否收表" min-width="100">
        <template slot-scope="{row}">
          <el-tag size="small " :type="row.collectionStatus === 2 ? 'primary' : row.collectionStatus === 3 ? 'warning' : 'danger'" disable-transitions>
            {{ enums.collectionStatus.filter(u => u.value === row.collectionStatus)[0].label }}
          </el-tag>
        </template>
      </el-table-column>
<!--      <el-table-column align="center" prop="remark" label="收表说明" min-width="200"/>-->
      <el-table-column align="center" prop="collectionUser" label="收表人" min-width="100"/>
      <el-table-column align="center" prop="type" label="体检类型" min-width="130">
        <template slot-scope="{row}">
            {{ row.type === 1 ? '只做常规,不抽血' : row.type === 2 ? '只抽血,不做常规' : '' }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="bloodTubeRemark" label="试管" min-width="100"/>
      <el-table-column align="center" prop="operator" label="最后操作人" min-width="150">
        <template #default="{ row }">
          <div>{{ row.operatorAccount }}</div>
          <div>{{ row.operator }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="updateTime" label="最后操作时间" min-width="160"/>
      <el-table-column align="center" prop="status" label="状态"  min-width="100">
        <template slot-scope="{row}">
          <el-switch v-model="row.status" :active-value="1" :inactive-value="2" @change="handleEditStatus(row, null, row.status)"/>
        </template>
      </el-table-column>
      <el-table-column fixed="right" align="center" prop="operation" label="操作"  min-width="340" id="elPopoverVisible">
        <template slot-scope="{row}">
          <el-button type="text" size="medium" @click="edit(row)" :disabled="row.status===2">编辑</el-button>
          <el-button type="text" size="medium" @click="physicalOrder(row)" :disabled="row.status===2">体检单</el-button>
          <el-popover placement="top" width="290" v-model="publishVisible['visible_' + row.index]" v-if="row.reportTemplateId" style="margin-left: 10px;margin-right: 10px;">
            <p style="display: flex; -webkit-box-align: center; align-items: center; line-height: 60px; font-size: 16px; ">
              <i class="el-popconfirm__icon el-icon-info" style="color: #409EFF;"/>确定<span v-if="row.publishStatus === 2">重新</span>发布体检报告到小程序？
            </p>
            <div style="text-align: right; margin: 0;line-height: 30px;">
              <el-button size="small" type="text" @click="cancel(row)" style="padding: 7px 15px;font-size: 12px;border-radius: 3px;background: #FFFFFF;border: 1px solid #DCDFE6;color: #606266;">取消</el-button>
              <el-button type="primary" size="small" @click="publish(row)">确定</el-button>
            </div>
            <a slot="reference" style="color: #409EFF;">发布</a>
          </el-popover>
          <el-popover placement="top" width="260" v-model="revocateVisible['visible_' + row.index]" v-if="row.publishStatus === 2" style="margin-left: 10px;margin-right: 10px;">
            <p style="display: flex; -webkit-box-align: center; align-items: center; line-height: 60px; font-size: 16px; ">
              <i class="el-popconfirm__icon el-icon-info" style="color: #409EFF;"/>确定撤回体检单的体检报告？
            </p>
            <div style="text-align: right; margin: 0;line-height: 30px;">
              <el-button size="small" type="text" @click="cancel(row)" style="padding: 7px 15px;font-size: 12px;border-radius: 3px;background: #FFFFFF;border: 1px solid #DCDFE6;color: #606266;">取消</el-button>
              <el-button type="primary" size="small" @click="revocate(row)">确定</el-button>
            </div>
            <a slot="reference" style="color: #409EFF;">撤回</a>
          </el-popover>
          <el-button type="text" size="medium" @click="evaluate(row)" :disabled="row.status===2">评价</el-button>
          <el-button type="text" size="medium" @click="barcode(row)" :disabled="row.status===2">条形码</el-button>
          <el-button type="text" size="medium" @click="printPhysicalForm(row)" :disabled="row.status===2">体检表</el-button>
          <el-button type="text" size="medium" @click="download(row)" :disabled="row.status===2">下载</el-button>
        </template>
      </el-table-column>
    </el-table>

    <Page :total="pageList.total" :current="pageList.currentPage" :page-size="pageList.pageSize"
          show-elevator show-sizer show-total @on-change="chagecurrent"
          :page-size-opts="[10, 30, 50, 100]"
          @on-page-size-change="chagepagesize" style="margin-top:10px;"/>

    <Modal v-model="editWindow" width="50%" :title="windowTitle" :styles="{'top':'60px'}" :mask-closable="false">
      <ScreeningDataInfoEdit ref="edit" @on-submit="handleSubmit" />
      <div slot="footer">
        <Button @click="editWindow = false">取消</Button>
        <Button type="primary" @click="submit">确定</Button>
      </div>
    </Modal>

    <el-dialog :title="importTitle" :visible.sync="importWindow" width="400px" custom-class="my-dialog"
               :destroy-on-close="true" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-upload ref="refUpload" action="#" :limit="1" class="upload-demo" drag multiple :auto-upload="false"
                 :on-change="handleChange" :on-remove="handleRemove"
                 :file-list="fileList">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div slot="tip" class="el-upload__tip">只能上传ecel文件，且不超过500kb</div>
      </el-upload>
      <div><a @click.stop="template()">文件模版</a></div>

      <span slot="footer" class="dialog-footer">
          <el-button  @click="handleCancle">取 消</el-button>
          <el-button type="primary" @click="handleUpload" :disabled="importDisabled">确 定</el-button>
        </span>
    </el-dialog>

    <!--批量打印条形码-->
    <Modal v-model="printWindow" title="条形码" :styles="{'top':'60px','text-align': 'center'}" :mask-closable="false">
      <PrintBarCode ref="printBarCode" :printCount.sync="printCount" :style="{'text-align':'center','overflow-y':'auto'}" @on-submit="handlePrint"/>
      <div style="text-align:left">每人 <el-input-number v-model="printCount" :min="1" label="请输入打印份数"/> 份</div>
      <div slot="footer">
        <Button type="primary" @click="toPrint">打印</Button>
      </div>
    </Modal>

    <!--批量下载体检报告-->
    <DownloadReport ref="downloadReport"/>
    <!--体检单-->
    <DataInfoDetail ref="dataInfoDetail" :taskList.sync="taskList" :schoolList.sync="schoolsList"
                    :barCode="search.barCode" :name="search.name" :idCard="search.idCard" :taskId="search.taskId"
                    :schoolId="search.schoolId" :gradeId="search.gradeId" :classesId="search.classesId"
                    @on-barCode="barcode"/>

    <span v-show="false"><printPhysicalForm ref="printPhysicalForm"/></span>
  </Content>
</template>
<script>
import {
  _page,
  _publish,
  _revocate,
  _barcode,
  _updateStatus,
  _batchEvaluate,
  _initEvaluate,
  _healthPromotionSystem,
  _healthPromotionEye,
  _uploadPhysicalData,
  _refraction,
  _physicalDataTemplate,
  _monitorRedisKey,
  _batchPrintNotice,
  _batchPublish,
  _batchRevocate,
  _export,
  _exportPhysicalDetail,
  _exportStatistics,
  _fullStatistics,
  _ophthalmology,
  _printPhysicalForm,
} from "@/services/screening/screeningDatainfo";
import ScreeningDataInfoEdit from "./ScreeningDataInfoEdit";
import DataInfoDetail from "./ScreeningDataInfoDetail.vue"
import PrintBarCode from "./PrintBarCode.vue"
import DownloadReport from "./DownloadReport.vue";
import PrintPhysicalForm from "./printPhysicalForm.vue";
import {_gradesList, _classesList} from "@/services/studentManage/studentManage";
import {mixins} from "@/mixins";
import {enums} from "@/services/enums";
import Vue from "vue";

export default {
  name: "ScreeningDataInfo",
  components: {
    PrintPhysicalForm, ScreeningDataInfoEdit, DownloadReport, PrintBarCode, DataInfoDetail
  },
  mixins: [mixins],
  computed: {

  },
  data() {
    return {
      modelPhysicalFormShow: false,
      moreCondition: false,
      tableHeight: 0,
      maxHeight: 0,
      currentRowIndex: null,
      enums: enums,
      editWindow: false,
      printWindow: false,
      isMaxHeight: false,
      importDisabled: false,
      publishVisible: {},
      revocateVisible:{},
      sourceType:1,
      windowTitle: "新增体检单",
      search: {
        name: "",
        idCard: "",
        businessTypeId: "",
        taskId: "",
        taskName: "",
        schoolId: "",
        gradeId: "",
        classesId: "",
        barCode: "",
        startTaskDate: "",
        endTaskDate: "",
        startPhysicalDate: "",
        endPhysicalDate: "",
        drawBloodStartDate: "",
        drawBloodEndDate: "",
        globalCheckStatus: "",
        convOptionsStatus: "",
        optionsStatus: "",
        conventional:"",
        bloodDraw:"",
        type:"",
        lisCheckStatus: "",
        publishStatus: "",
        collectionStatus: "",
        status: 1,
        physicalIds:"",
      },
      fileList:[],
      importTitle:"",
      importWindow:false,
      lisCheckStatusList:[
        {label: '全部', value: ''},
        {label: '未抽血', value: 1},
        {label: '部分抽血', value: 2},
        {label: '已抽血', value: 3},
      ],
      collectionStatusList:[
        {label: '全部', value: ''},
        {label: '待收表', value: 1},
        {label: '已收表', value: 2},
        {label: '取消收表', value: 3},
      ],
      convOptionsStatusList:[
        {label: '全部', value: ''},
        {label: '无', value: 1},
        {label: '有', value: 2},
      ],
      optionsStatusList:[
        {label: '全部', value: ''},
        {label: '无', value: 1},
        {label: '有', value: 2},
      ],
      conventionalList:[
        {label: '全部', value: ''},
        {label: '体检', value: 1},
        {label: '不体检', value: 2},
      ],
      bloodDrawList:[
        {label: '全部', value: ''},
        {label: '抽血', value: 1},
        {label: '不抽血', value: 2},
      ],
      typeList:[
        {label: '全部', value: ''},
        {label: '只做常规,不抽血', value: 1},
        {label: '只抽血,不做常规', value: 2},
      ],
      notifyInstance:null,
      wrapper:null,
      notifications: {}, // { id: { instance, timer } }
      progressTimer:null,
      progress: 0,
      printCount:3,
      physicalIdList:[],
      taskList: [],
      schoolList: [],
      gradeList: [],
      classesList: [],
      dataList:[],
      pageList: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
    };
  },
  created(){
    this.setDynamicHeight();
    window.addEventListener('resize', this.setDynamicHeight);
  },
  mounted() {
    if (this.$userSession.checkInstitutionId()) {
      this.handleDataList();
      this.applyTaskList();
      this.applyBusinessTypes();
      this.applySchoolsList();
    }
  },
  beforeDestroy() {
    Object.values(this.notifications).forEach(({ timer }) => {
      clearInterval(timer);
    });
    this.$notify.closeAll(); // 关闭所有通知
  },
  methods: {
    setDynamicHeight() {
      const height = window.innerHeight || document.documentElement.clientHeight;
      if(!this.moreCondition){
        this.tableHeight = `${height - 280}px`;
      }else{
        this.tableHeight = `${height - 380}px`;
      }
      this.maxHeight = `${height - 350}px`;
    },
    moreConditionHandle(){
      this.moreCondition = !this.moreCondition;
      this.setDynamicHeight();
      window.addEventListener('resize', this.setDynamicHeight);
    },
    changeSchool(schoolId) {
      if (!schoolId) {
        this.gradeList = [];
        this.classesList = [];
        this.search.gradeId = "";
        this.search.classesId = "";
        return;
      }
      _gradesList({schoolId: schoolId}).then(res => {
        this.search.schoolId = schoolId;
        this.search.gradeId = "";
        this.search.classesId = "";
        if (res.errcode === 1 && res.data) {
          this.gradeList = res.data;
        } else {
          this.gradeList = []
        }
      })
    },
    changeGrade(gradeId) {
      if (!gradeId) {
        this.classesList = [];
        this.search.classesId = "";
        return;
      }
      _classesList({schoolId:this.search.schoolId, gradeId: gradeId}).then(res => {
        this.search.gradeId = gradeId;
        this.search.classesId = "";
        if (res.errcode === 1 && res.data) {
          this.classesList = res.data;
        } else {
          this.classesList = []
        }
      })
    },
    handleTaskChange(item) {
      this.search.taskId = item.id;
      this.search.taskName = item.name;
      this.search.taskPhysicalDate = item.physicalDate;
    },
    handleShoolChange(item) {
      this.search.schoolId = item.value;
    },
    handleGradeChange(item) {
      this.search.gradeId = item.id;
    },
    handleClassChange(item) {
      this.search.classesId = item.id;
    },
    handleEditStatus(row, index, targetValue){
      if(row && row.id){
        return new Promise((resolve,reject) => {
          this.$confirm(`是否确定${targetValue === 1 ? "启用" : "停用"}${row.name}吗?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            dangerouslyUseHTMLString: true,
            type: 'warning'
          }).then((result)=>{
            _updateStatus({physicalId:row.physicalId, status: targetValue}).then(res =>{
              if (res.errcode === 1) {
                this.handleDataList();
              }else {
                this.$message.error(res.errmsg);
                reject()
              }
            }).catch(() => {
              reject()
            });
          }).catch(function (e) {
            if (e === 'cancel' || e === 'close') {
              row.status = (targetValue === 1 ? 2 : 1);
            }
          })
        });
      }
    },
    query() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }
      this.pageList.currentPage = 1;
      this.handleDataList();
    },
    handleDataList() {
      this.search.physicalIds = "";
      this.physicalIdList = [];

      _page({
        ...this.search,
        ...this.pageList,
      }).then(res => {
        if (res.errcode === 1 && res.data && res.data.records && res.data.records.length > 0) {
          for (let index = 0; index < res.data.records.length; index++) {
            this.publishVisible['visible_' + index] = false;
            this.revocateVisible['visible_' + index] = false;
          }
        }

        this.dataList = res.data.records;
        this.pageList.total = res.data.total;
      }).catch(() => {});
    },
    cancel(row){
      this.$nextTick(()=>{
          document.getElementById('elPopoverVisible').click();
      })
      this.publishVisible[row.index] = false;
      this.revocateVisible[row.index] = false;
      // this.$set(this.publishVisible, 'visible_' + row.index, true);
      // this.$set(this.revocateVisible, 'visible_' + row.index, true);
      this.$nextTick(()=>{ this.$forceUpdate();})
    },
    handleCreate() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }
      this.windowTitle = "新增";
      this.editWindow = true;
      this.$refs["edit"].handleModal();
    },
    edit(row) {
      this.windowTitle = "编辑";
      this.editWindow = true;
      this.$refs["edit"].handleModal(row);
    },
    submit() {
      this.$refs['edit'].handleSubmit();
    },
    handleSubmit(result) {
      if (!result) {
        this.editWindow = result;
        this.handleDataList();
      }
    },
    chiefInspector(){
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }
      this.$refs['dataInfoDetail'].handleShow();
    },
    physicalOrder(row) {
      this.$refs['dataInfoDetail'].handleShow(row);
    },
    publish(row) {
      this.$nextTick(()=>{
        document.getElementById('elPopoverVisible').click();
      })
      _publish({physicalId: row.physicalId}).then(res => {
        if (res.errcode === 1) {
          this.$message.success('发布成功');
          this.handleDataList();
        } else {
          this.$message.error(res.errmsg);
        }
      }).catch(() => {});
    },
    revocate(row) {
      this.$nextTick(()=>{
        document.getElementById('elPopoverVisible').click();
      })
      _revocate({physicalId: row.physicalId}).then(res => {
        if (res.errcode === 1) {
          this.$message.success('撤回成功');
          this.handleDataList();
        } else {
          this.$message.error(res.errmsg);
        }
      }).catch(() => {});
    },
    barcode(row){

      if(row.taskPhysicalDate && row.taskPhysicalDate.substring(0, 4) != new Date().getFullYear()) {
        this.$confirm("<h3>该学生所在体检任务体检日期为： <span style='color: #dd0000'>" + row.taskPhysicalDate + "</span>， 请确认是否打印</h3>", "提示", {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          showClose:false,
          closeOnClickModal:false,
          dangerouslyUseHTMLString: true,
          customClass: 'custom-confirm-width',
        }).then(() => {
          _barcode({physicalId: row.physicalId}).then(res=>{
            if (res.errcode === 1){
              this.printCount = 3;
              this.printWindow = true;
              this.isMaxHeight = true;
              this.$refs["printBarCode"].barcodeList = [];
              this.$refs["printBarCode"].barcodeList.push(res.data);
              // this.$refs["printBarCode"].handleModal({barCode : row.barCode}, false);
            }else{
              this.$message.error(res.errmsg);
            }
          }).catch(e=>{})
        }).catch(() => {
        }).finally(() => {})
      }else{
        _barcode({physicalId: row.physicalId}).then(res=>{
          if (res.errcode === 1){
            this.printCount = 3;
            this.printWindow = true;
            this.isMaxHeight = true;
            this.$refs["printBarCode"].barcodeList = [];
            this.$refs["printBarCode"].barcodeList.push(res.data);
            // this.$refs["printBarCode"].handleModal({barCode : row.barCode}, false);
          }else{
            this.$message.error(res.errmsg);
          }
        }).catch(e=>{})
      }
    },
    toPrint(){
      this.printWindow = false;
      this.$refs["printBarCode"].print();
    },
    handlePrint(){

    },
    printPhysicalForm(row){
      this.$refs["printPhysicalForm"].batchPhysicalForm({barCode: row.barCode});
      /*_printPhysicalForm({barCode: row.barCode}).then(res=>{
        if (res.errcode === 1){
          this.$refs["printPhysicalForm"].physicalFormDataList = [];
          this.$refs["printPhysicalForm"].physicalFormDataList.push(res.data);
          this.$refs["printPhysicalForm"].print();
        }else{
          this.$message.error(res.errmsg);
        }
      }).catch(e=>{})*/
    },
    download(row){
      this.$refs["downloadReport"].handleModal({barCode: row.barCode, physicalId: row.physicalId, type: 1});
    },
    evaluate(row){
      _batchEvaluate({barCode: row.barCode}).then(res=>{
        if (res.errcode === 1){
          this.$message.success("评价成功");
        }else{
          this.$message.error(res.errmsg);
        }
      }).catch(e=>{
      })
    },
    getDaysBetweenDates(date1, date2) {
      let date1Parts = date1.split('-');
      let date2Parts = date2.split('-');

      let date1Time = new Date(date1Parts[0], date1Parts[1] - 1, date1Parts[2]).getTime();
      let date2Time = new Date(date2Parts[0], date2Parts[1] - 1, date2Parts[2]).getTime();

      return Math.floor(Math.abs(date2Time - date1Time) / (24 * 60 * 60 * 1000));
    },
    exportData() {
      let param = {...this.search};
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }else if (!this.search.taskId&&!this.search.startPhysicalDate&&!this.search.endPhysicalDate&&!this.search.startTaskDate&&!this.search.endTaskDate) {
        this.$message.warning("请先选择体检任务！！")
        return;
      }else if (!this.search.taskId&&!this.search.startPhysicalDate&&!this.search.startTaskDate) {
        this.$message.warning("请先选择开始日期！！")
        return;
      }else if (!this.search.taskId&&!this.search.endPhysicalDate&&!this.search.endTaskDate) {
        this.$message.warning("请先选择结束日期！！")
        return;
      }else if (this.search.taskId) {
        param.startPhysicalDate = "";
        param.endPhysicalDate = "";
        param.startTaskDate = "";
        param.endTaskDate = "";
      }else{
        param.taskId = "";
      }

      if((param.startPhysicalDate&&param.endPhysicalDate&&this.getDaysBetweenDates(param.startPhysicalDate, param.endPhysicalDate)>91)
        || (param.startTaskDate&&param.endTaskDate&&this.getDaysBetweenDates(param.startTaskDate, param.endTaskDate)>91)){
        this.$message.warning('日期范围不能超过三个月');
        return;
      }

      if(this.physicalIdList && this.physicalIdList.length > 0){
        this.search.physicalIds = this.physicalIdList.toString();
      }else{
        this.search.physicalIds = "";
      }
      _export(param).then(res => {
          if (res && res.errcode && res.errcode === 1) {
            this.search.physicalIds = "";
            this.physicalIdList = [];
          } else {
            this.$Message.error(res.errmsg);
          }
      }).catch(error => {
        console.log("error", error)
      });
    },
    exportPhysicalDetail() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }else if (!this.search.taskId&&!this.search.startPhysicalDate&&!this.search.endPhysicalDate&&!this.search.startTaskDate&&!this.search.endTaskDate) {
        this.$message.warning("请先选择体检任务！！")
        return;
      }

      if(this.physicalIdList && this.physicalIdList.length > 0){
        this.search.physicalIds = this.physicalIdList.toString();
      }else{
        this.search.physicalIds = "";
      }
      _exportPhysicalDetail(this.search).then(res => {
        if (res && res.errcode && res.errcode === 1) {
          this.search.physicalIds = "";
          this.physicalIdList = [];
        } else {
          this.$Message.error(res.errmsg);
        }
      }).catch(error => {
        console.log("error", error)
      });
    },
    exportOphthalmology(){
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }

      if (!this.search.taskId && !this.search.schoolId) {
        this.$message.warning("请先选择体检任务或学校！！")
        return;
      }

      _ophthalmology(this.search).then(res => {
        if (res && res.errcode && res.errcode === 1) {
          this.search.physicalIds = "";
          this.physicalIdList = [];
        } else {
          this.$Message.error(res.errmsg);
        }
      }).catch(error => {
        console.log("error", error)
      });
    },
    handleStatisticsClick(command){
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }

      if (command == "2" && this.physicalIdList.length === 0 && !this.search.name && !this.search.barCode && !this.search.idCard
          && !this.search.schoolId && !this.search.gradeId && !this.search.classesId && !this.search.taskId) {
        this.$message.warning("请先输入或选择条件！！")
        return;
      }

      if(command === "1") {
        this.exportTaskStatistics();
      } else if(command === "2") {
        this.exportStatistics();
      }
    },
    exportStatistics() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }else if (this.physicalIdList.length === 0 && !this.search.name && !this.search.barCode && !this.search.idCard
        && !this.search.schoolId && !this.search.gradeId && !this.search.classesId && !this.search.taskId) {
        this.$message.warning("请先输入或选择条件！！")
        return;
      }

      if(this.physicalIdList && this.physicalIdList.length > 0){
        this.search.physicalIds = this.physicalIdList.toString();
      }else{
        this.search.physicalIds = "";
      }
      _exportStatistics(this.search).then(res => {
        if (res && res.errcode && res.errcode === 1) {
          this.search.physicalIds = "";
          this.physicalIdList = [];
        } else {
          this.$Message.error(res.errmsg);
        }
      }).catch(error => {
        console.log("error", error)
      });
    },
    exportTaskStatistics(){
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }

      if(this.physicalIdList && this.physicalIdList.length > 0){
        this.search.physicalIds = this.physicalIdList.toString();
      }else{
        this.search.physicalIds = "";
      }
      _fullStatistics(this.search).then(res => {
        if (res && res.errcode && res.errcode === 1) {
          this.search.physicalIds = "";
          this.physicalIdList = [];
        } else {
          this.$Message.error(res.errmsg);
        }
      }).catch(error => {
        console.log("error", error)
      });
    },
    handleHealthPromotionClick(command){
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }else if (!this.search.taskId) {
        this.$message.warning("请先选择体检任务！！")
        return;
      }

      if(this.physicalIdList && this.physicalIdList.length > 0){
        this.search.physicalIds = this.physicalIdList.toString();
      }else{
        this.search.physicalIds = "";
      }

      if(command === "1") {
        this.healthPromotionSystem();
      } else if(command === "2") {
        this.healthPromotionEye();
      }
    },
    healthPromotionSystem(){
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }else if (!this.search.taskId) {
        this.$message.warning("请先选择体检任务！！")
        return;
      }

      if(this.physicalIdList && this.physicalIdList.length > 0){
        this.search.physicalIds = this.physicalIdList.toString();
      }else{
        this.search.physicalIds = "";
      }

      _healthPromotionSystem(this.search).then(res => {
        if (res && res.errcode && res.errcode === 1) {
          this.search.physicalIds = "";
          this.physicalIdList = [];
        } else {
          this.$Message.error(res.errmsg);
        }
      }).catch(error => {
        console.log("error", error)
      });
    },
    healthPromotionEye(){
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }else if (!this.search.taskId) {
        this.$message.warning("请先选择体检任务！！")
        return;
      }

      if(this.physicalIdList && this.physicalIdList.length > 0){
        this.search.physicalIds = this.physicalIdList.toString();
      }else{
        this.search.physicalIds = "";
      }

      _healthPromotionEye(this.search).then(res => {
        if (res && res.errcode && res.errcode === 1) {
          this.search.physicalIds = "";
          this.physicalIdList = [];
        } else {
          this.$Message.error(res.errmsg);
        }
      }).catch(error => {
        console.log("error", error)
      });
    },
    template(){
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }
      _physicalDataTemplate({type: this.sourceType}).then(res => {}).catch(error => {});
    },
    handleImportClick(command){
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }
      this.sourceType = command;

      this.fileList = [];
      if(command === "2"){
        this.importTitle = "屈光数据";
      }else{
        this.importTitle = "视力屈光";
      }
      this.importWindow = true;
      this.importDisabled=false;
    },
    handleChange(file, fileList){
      if (!this.$userSession.checkInstitutionId()) {
        this.importDisabled = false;
        this.$message.warning('请先选择机构');
        return
      }
      this.fileList = fileList;
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
      this.importDisabled = false;
      this.$nextTick(() => {
        this.$refs.refUpload.clearFiles();
      });
    },
    handleCancle() {
      this.fileList = [];
      this.importWindow = false;
      this.importDisabled = false;
      this.$nextTick(() => {
        this.$refs.refUpload.clearFiles();
      });
    },
    handleUpload(){
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return
      }else if(!this.fileList || this.fileList.length === 0){
        this.$message.warning('请先选择需要上传的文件');
        return;
      }
      this.importDisabled = true;

      if(this.sourceType === "1"){
        this.uploadPhysicalData(this.fileList[0].raw);
      }else{
        this.refraction(this.fileList[0].raw);
      }
    },
    uploadPhysicalData(file){
      _uploadPhysicalData({file: file}).then(res=>{
        if (res && res.errcode && res.errcode === 1){
          this.fileList = [];
          this.importWindow = false;
          this.importDisabled = false;

          if(res.data && res.data.length > 0) {
            let message = "";
            res.data.forEach((item, index) => {
              message += "<div>" + (index + 1) + "、<span>" + item + "</span></div>";
            });

            this.$alert(message, '提示', {
              distinguishCancelAndClose: true,
              dangerouslyUseHTMLString: true,
            }).then(() => {
              this.handleDataList();
            }).catch(() => {
              this.handleDataList();
            });
          }else{
            this.$message.success("上传成功");
            this.handleDataList()
          }
        } else if(res){
          this.importDisabled = false;
          this.$message({
            type: 'error',
            message: res.errmsg,
            duration: 3000,
            center: true
          });
        }
      }).catch(res=>{
        this.importDisabled = false;
        /*this.$message({
          type: 'error',
          message: "上传失败",
          duration: 3000,
          center: true
        });*/
      }).finally(() =>{
        this.importDisabled = false;
      })
    },
    refraction(file){
      _refraction({file: file}).then(res=>{
        if (res && res.errcode && res.errcode === 1){
          this.fileList = [];
          this.importWindow = false;
          this.importDisabled = false;

          if(res.data && res.data.length > 0) {
            let message = "";
            res.data.forEach((item, index) => {
              message += "<div>" + (index + 1) + "、<span>" + item + "</span></div>";
            });

            this.$alert(message, '提示', {
              distinguishCancelAndClose: true,
              dangerouslyUseHTMLString: true,
            }).then(() => {
              this.handleDataList();
            }).catch(() => {
              this.handleDataList();
            });
          }else{
            this.$message.success("上传成功");
            this.handleDataList()
          }
        } else if(res){
          this.importDisabled = false;
          this.$message({
            type: 'error',
            message: res.errmsg,
            duration: 3000,
            center: true
          });
        }
      }).catch(res=>{
        this.importDisabled = false;
        /*this.$message({
          type: 'error',
          message: "上传失败",
          duration: 3000,
          center: true
        });*/
      }).finally(() =>{
        this.importDisabled = false;
      })
    },
    batchEvaluate() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }else if (!this.search.taskId) {
        this.$message.warning("请先选择体检任务！！")
        return;
      }

      this.$confirm('<h3>是否确定执行批量健康评价？</h3>', '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false,
      }).then(() => {
        if(this.physicalIdList && this.physicalIdList.length > 0){
          this.search.physicalIds = this.physicalIdList.toString();
        }else{
          this.search.physicalIds = "";
        }

        this.search.redisKey = "physical:initEvaluation:" + new Date().getTime();
          _initEvaluate(this.search).then(res => {
          if (res && res.errcode && res.errcode === 1) {
            this.search.physicalIds = "";
            this.physicalIdList = [];
            this.startLoad();
            // this.$message.success("执行批量健康评价完成")
            // this.handleDataList();
          } else {
            this.$Message.error(res.errmsg);
          }
        }).catch(() => {});

      }).catch(() => {}).finally(() => {});
    },
    startLoad() {
      let _this = this;

      this.showNotification();
      this.progressTimer = setInterval(() => {

        _this.updateProgress();
        if (this.wrapper.progressValue >= 100) {
          clearInterval(this.progressTimer);
          setTimeout(() => {
            _this.closeCurrentNotification();
            /*_this.$notify({
              dangerouslyUseHTMLString: true,
              title:'提示',
              message: '<div style="font-size: 15px;">批量健康评价已执行完成</div>',
              type:'success',
            });*/
          }, 2000);
        }
      }, 500);
    },
    updateProgress(){
      // 找到通知的DOM元素并插入内容
      const notificationEl = document.querySelector('.custom-notify')
      const contentEl = notificationEl.querySelector('.el-notification__content')

      _monitorRedisKey({redisKey:this.search.redisKey}).then(res => {
        if (res && res.errcode && res.errcode === 1 && res.data) {
          contentEl.innerHTML = ''
          contentEl.appendChild(this.wrapper.$el);
          this.wrapper.progressValue = parseInt(res.data);
        } else {
          let divHtml = "<div style='white-space:pre-wrap;word-break:break-all;overflow-wrap:break-word;'>" + this.search.taskName + "</div>";
          divHtml += "<div style='white-space:pre-wrap;word-break:break-all;overflow-wrap:break-word;color:#FF5252;'>处理失败</div>";
          contentEl.innerHTML = divHtml;
          setTimeout(() => {
            this.closeCurrentNotification();
          }, 2000);
        }
      }).catch(() => {
        clearInterval(this.progressTimer);
      });
    },
    showNotification() {
      let _this = this;
      this.wrapper = new Vue({
        data() {
          return { progressValue: 0}
        },
        render(h) {
          return h('div', { style: 'width: 100%;font-size:17px;' }, [
            h('div', {style: {'white-space': 'pre-wrap','word-break': 'break-all','overflow-wrap': 'break-word'}}, _this.search.taskName),
            h('el-progress',{props:{percentage:this.progressValue, strokeWidth:10}}),
            h('div', { style: 'text-align: left' }, [
              h('el-button', {
                props: {size: 'small', type: 'danger'},
                on: {click: () => _this.closeCurrentNotification()}
              }, '取消')
            ])
          ])
        }
      }).$mount()

      const className = `custom-notify`;
      const style = document.createElement("style");
      style.innerHTML = `
        .${className} {word-break: break-word !important;}
        .el-notification__group {width: 100% !important;}`;
      document.head.appendChild(style);

      this.notifyInstance = this.$notify({
        title: '提示',
        message: _this.wrapper.$el.outerHTML,
        dangerouslyUseHTMLString: true,
        duration: 0,
        showClose:false,
        offset: 90,
        customClass: className,
      })
    },
    closeCurrentNotification() {
      if(this.progressTimer){
        clearInterval(this.progressTimer); // 清除定时器
      }

      if (this.notifyInstance) {
        this.notifyInstance.close(); // 手动关闭通知
        this.notifyInstance = null;
        this.wrapper = null;

        _monitorRedisKey({redisKey:this.search.redisKey,status:"cancel"}).then(res => {}).catch(() => {});
      }
    },
    addNotification() {
      this.notifications[this.search.taskId] = {
        instance: this.$notify(this.notifyInstance),
        timer: setInterval(() => {  })
      };
    },
    closeNotification() {
      let _notifyInstance = this.notifications[this.search.taskId];
      if(_notifyInstance){
        _notifyInstance.instance.close();
        clearInterval(_notifyInstance.timer);
        delete this.notifications[this.search.taskId];
      }
    },
    batchPublish() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }else if (!this.search.taskId) {
        this.$message.warning("请先选择体检任务！！")
        return;
      }

      this.$confirm('<h3>确定发布搜索条件下体检单的体检报告到小程序吗？</h3>', '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false,
      }).then(() => {
        if(this.physicalIdList && this.physicalIdList.length > 0){
          this.search.physicalIds = this.physicalIdList.toString();
        }else{
          this.search.physicalIds = "";
        }
        _batchPublish(this.search).then(res => {
          if (res && res.errcode && res.errcode === 1) {
            this.$message.success("批量发布成功")
            this.handleDataList();
          } else {
            this.$Message.error(res.errmsg);
          }
        }).catch(() => {});
      }).catch(() => {});

      /*
      this.$Modal.confirm({
        title: "<h2>提示</h2>",
        width: '26%',
        content: '<h3>确定发布搜索条件下体检单的体检报告到小程序吗？</h3>',
        okText: "确定",
        cancelText: '取消',
        onOk: () => {
          if(this.physicalIdList && this.physicalIdList.length > 0){
            this.search.physicalIds = this.physicalIdList.toString();
           }else{
            this.search.physicalIds = "";
          }
          _batchPublish(this.search).then(res => {
            if (res && res.errcode && res.errcode === 1) {
              this.$message.success("批量发布成功")
              this.handleDataList();
            } else {
              this.$Message.error(res.errmsg);
            }
          }).catch(() => {});
        },
        onCancel: () => {}
      });
       */
    },
    batchRevocate() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }else if (!this.search.taskId) {
        this.$message.warning("请先选择体检任务！！")
        return;
      }

      this.$confirm('<h3>确定撤回搜索条件下体检单的体检报告？</h3>', '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false,
      }).then(() => {
        if(this.physicalIdList && this.physicalIdList.length > 0){
          this.search.physicalIds = this.physicalIdList.toString();
        }else{
          this.search.physicalIds = "";
        }
        _batchRevocate(this.search).then(res => {
          if (res && res.errcode && res.errcode === 1) {
            this.$message.success("批量撤回成功")
            this.handleDataList();
          } else {
            this.$Message.error(res.errmsg);
          }
        }).catch(() => {});
      }).catch(() => {});
    },
    batchPrintNotice() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }else if (!this.search.taskId) {
        this.$message.warning("请先选择体检任务！！")
        return;
      }

      this.$confirm('<h3>是否确定执行批量打印协议书？</h3>', '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false,
      }).then(() => {
        if(this.physicalIdList && this.physicalIdList.length > 0){
          this.search.physicalIds = this.physicalIdList.toString();
        }else{
          this.search.physicalIds = "";
        }
        _batchPrintNotice(this.search).then(res => {
          if (res && res.errcode && res.errcode === 1) {
            this.$message.success("批量打印协议书成功")
            this.handleDataList();
          } else {
            this.$Message.error(res.errmsg);
          }
        }).catch(() => {});
      }).catch(() => {});
    },
    batchPrintBarcode() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }else if (!this.search.taskId) {
        this.$message.warning("请先选择体检任务！！")
        return;
      }

      if(this.search.taskPhysicalDate && this.search.taskPhysicalDate.substring(0, 4) != new Date().getFullYear()){
        this.$confirm("<h3>当前体检任务体检日期为： <span style='color: #dd0000'>" + this.search.taskPhysicalDate + "</span>， 请确认是否打印</h3>", "提示", {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          showClose:false,
          closeOnClickModal:false,
          dangerouslyUseHTMLString: true,
          customClass: 'custom-confirm-width',
        }).then(() => {
          if(this.physicalIdList && this.physicalIdList.length > 0){
            this.search.physicalIds = this.physicalIdList.toString();
          }else{
            this.search.physicalIds = "";
          }
          this.printCount = 3;
          this.printWindow = true;
          this.$refs["printBarCode"].handleModal(this.search);
        }).catch(() => {
        }).finally(() => {})
      }else{
        if(this.physicalIdList && this.physicalIdList.length > 0){
          this.search.physicalIds = this.physicalIdList.toString();
        }else{
          this.search.physicalIds = "";
        }
        this.printCount = 3;
        this.printWindow = true;
        this.$refs["printBarCode"].handleModal(this.search);
      }
    },
    batchPhysicalForm(){
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }else if (!this.search.taskId) {
        this.$message.warning("请先选择体检任务！！")
        return;
      }

      if(this.physicalIdList && this.physicalIdList.length > 0){
        this.search.physicalIds = this.physicalIdList.toString();
      }else{
        this.search.physicalIds = "";
      }
      this.$refs["printPhysicalForm"].batchPhysicalForm(this.search);
    },
    batchDownLoadReport() {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }else if (!this.search.taskId && !this.search.barCode && !this.search.idCard && !this.search.name) {
        this.$message.warning("请先选择体检任务！！")
        return;
      }

      if(this.pageList.total == 1){
        this.$refs["downloadReport"].handleModal({barCode: this.dataList[0].barCode, physicalId: this.dataList[0].physicalId, type: 1});
      }else if(this.search.barCode){
        this.$refs["downloadReport"].handleModal({barCode: this.search.barCode, physicalId: this.dataList[0].physicalId, type: 1});
      }else{
        if(this.physicalIdList && this.physicalIdList.length > 0){
          this.search.physicalIds = this.physicalIdList.toString();
        }
        this.$refs["downloadReport"].handleModal(this.search);
      }
    },
    tableRowClassName(row, rowIndex) {
      row.row.index = row.rowIndex;
      if (this.currentRowIndex === row.rowIndex) {
        return "select-row";
      }else{
        return "";
      }
    },
    handleRowClick(e, index, event){
      this.currentRowIndex = e.index;
    },
    selectList(e) {
      this.physicalIdList = []
      e.forEach(item=>{
        this.physicalIdList.push(item.physicalId)
      })
    },
    chagecurrent(e) {
      this.pageList.currentPage = e
      this.handleDataList()
    },
    chagepagesize(e) {
      this.pageList.pageSize = e
      this.handleDataList()
    },
    changeTaskStart(e) {
      this.search.startTaskDate = e
    },
    changeTaskEnd(e) {
      this.search.endTaskDate = e
    },
    changestart(e) {
      this.search.startPhysicalDate = e
    },
    changeend(e) {
      this.search.endPhysicalDate = e
    },
    changeDrawBloodStart(e) {
      this.search.drawBloodStartDate = e
    },
    changeDrawBloodEnd(e) {
      this.search.drawBloodEndDate = e
    },
    toInt(){
      if(this.search.barCode){
        this.search.barCode = (this.search.barCode + "").replace(/[^\d]+/g, '');
        this.search.barCode = (this.search.barCode + "").replace('.', '');
        this.search.barCode = (this.search.barCode + "").replace(/\./g, '');
        this.search.barCode = (this.search.barCode + "").replace(/\\./g, '');
        this.search.barCode = (this.search.barCode + "").replace('$#$', '');
      }
    }
  }
};
</script>
<style lang="postcss" scoped>
/deep/ #searchForm .ivu-form-item {margin-bottom: 6px;vertical-align: top;zoom: 1;}
/deep/ .el-table__body tr.select-row>td.el-table__cell{background-color: #beffc5;color: #101010;}
/deep/ .el-input__inner {height: 30px;line-height: 30px;}
/deep/ .el-input__icon{line-height: 30px;}
/deep/ .el-input-number .el-input__inner {height: 40px;line-height: 40px;}
/deep/ .el-input-number .el-input__icon{line-height: 40px;}
/deep/ .el-input--suffix .el-input__inner {padding-right: 0px;}
/deep/ .el-dialog__body {padding: 5px 20px;}
/deep/ .el-table .el-table__cell {padding: 10px 0;}
/deep/ .el-button--mini {padding: 5px 10px;}
</style>
